import * as Api from '@ViewModels';

/**
 * Check if an AccountProfile has any of the discrete content preference fields populated.
 * Does not include legacy businessDescription — use hasContentPreferences for that.
 */
export function hasDiscreteContentPreferences(profile: Api.AccountProfile | null | undefined): boolean {
	if (!profile) return false;
	return !!(
		profile.location ||
		profile.address ||
		profile.phoneNumber ||
		profile.pronouns ||
		profile.tonePreference ||
		profile.contentGoals
	);
}

/**
 * Check if an AccountProfile has any content preference data configured,
 * including both discrete fields and legacy businessDescription.
 */
export function hasContentPreferences(profile: Api.AccountProfile | null | undefined): boolean {
	if (!profile) return false;
	return !!(
		hasDiscreteContentPreferences(profile) ||
		profile.businessDescription ||
		profile.messagingPreferences?.keywords
	);
}

// Admins impersonating a customer can customize content with AI even when the account has
// no content preferences configured. https://github.com/Real-Magic/Levitate/issues/19177
export function canCustomizeContentWithAi(
	profile: Api.AccountProfile | null | undefined,
	isImpersonating: boolean
): boolean {
	return isImpersonating || hasContentPreferences(profile);
}
